import {
  headerCellStyle,
  locationStyle,
  tableBodyStyle,
  tableCellStyle,
  tableContainerStyle,
  tableHeaderStyle,
  tableRowStyle,
  tableStyle
} from './GameTableStyles';

const Table = ({ data }: any) => {
  return (
    <>
      <div css={tableContainerStyle}>
        <table css={tableStyle}>
          <tr css={tableHeaderStyle}>
            <th css={headerCellStyle}>#</th>
            <th css={headerCellStyle}>Name</th>
            <th css={headerCellStyle}>Location</th>
          </tr>
          <tbody css={tableBodyStyle}>
            {data?.winners?.map((row: any, i: number) => (
              <tr css={tableRowStyle} key={`${i + 1}`}>
                <td css={tableCellStyle}>{`${i + 1}`}</td>
                <td css={tableCellStyle}>{row.name}</td>
                <td css={tableCellStyle}>
                  <span css={locationStyle}>
                    <img
                      src={`/webapp-assets/images/ILT/pinLocationIcon.svg?v=${process.env.APP_VERSION}`}
                      alt=""
                    />
                    {row.location}
                  </span>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </>
  );
};

export default Table;
